module.exports = __webpack_public_path__ + "static/google-play-reversed-1b6bf338dc83986162749e674b177604.svg";